import { datePickerStyle } from '@bingads-webui-campaign-react/common-styles';

const calloutCloseButtonStyle = {
  top: 9,
  right: 8,
  width: 12,
  border: 0,
  height: 13,
  padding: 0,
  position: 'absolute',
  background: 'inherit',
  minWidth: 12,
};

export const getSummaryBarStyle = (_, { palette = {} }) => ({
  '@global': {
    ...datePickerStyle({ palette }),
    '.summary-bar-items > div': {
      '& > div:nth-child(2)': {
        minHeight: '0px !important',
      },
      '& .iconba-Edit': {
        opacity: 0,
      },
      '& .entity-multi-content': {
        maxWidth: '180px !important',
        '& .entity-first-item': {
          minWidth: '20px',
        },
      },
      '&:hover, &:active, &:focus': {
        background: 'transparent !important',
      },
      '&.editable': {
        '& > div:focus': {
          '& .iconba-Edit': {
            opacity: 1,
          },
        },
        '&:hover, &:active, &:focus': {
          backgroundColor: '#e1dfdd !important',
          '& .iconba-Edit': {
            opacity: 1,
          },
        },
        cursor: 'pointer',
        '& .entity-content-settings': {
          paddingTop: '11px',
          paddingBottom: '10px',
        },
      },
    },
    '#summary-bar-campaign-inline-budget-editor': {
      minWidth: '500px',
      '& .bingads-webui-react-callout-close-button': calloutCloseButtonStyle,
    },
    '#summary-bar-shared-budget-editor, #summary-bar-campaign-shared-budget-editor': {
      minWidth: '280px',
      maxWidth: '500px',
      '& .bingads-webui-react-callout-close-button': calloutCloseButtonStyle,
      '& .popover-title': {
        wordBreak: 'break-word',
      },
    },
    '#summary-bar-campaign-experiment-budget-editor': {
      width: '280px',
      '& .bingads-webui-react-callout-close-button': calloutCloseButtonStyle,
    },
    '#summary-bar-adgroup-bid-editor': {
      minWidth: '255px',
    },
    '#summary-bar-experiment-campaign-end-editor, #summary-bar-experiment-campaign-start-editor': {
      minWidth: '400px',
    },
    '.summary-bar-experiment-split-option span.entity-label': {
      marginTop: '3px',
    },
    '.summary-bar-original-campaign .entity-link': {
      '&:hover, &:active, &:focus': {
        '& .entity-text': {
          color: '#0078d4 !important',
        },
      },
    },
    '.alert-info-inline': {
      '& a': {
        color: '#106ebe',
      },
    },
    '.summary-bar-contextual-menu-popover-close-button': {
      top: '9px',
      width: '12px',
      right: '8px',
      border: '0',
      height: '13px',
      padding: '0',
      position: 'absolute',
      maxWidth: '12px',
      minWidth: '12px',
      background: 'inherit',
      maxHeight: '13px',
      minHeight: '13px',
    },
    '.summary-bar-contextual-menu-popover-button': {
      background: 'transparent',
      border: 'none',
      width: '100%',
      padding: '7px 10px',
    },
    '.overflow-entity-items': {
      '& .ms-ContextualMenu-Callout': {
        maxWidth: '250px',
        '& > .ms-Callout-main': {
          overflow: 'visible',
        },
        '& .ms-ContextualMenu-link': {
          '&:focus': {
            '& .overflow-item.editable': {
              backgroundColor: '#f3f2f1',
              '& .iconba-Edit': {
                opacity: 1,
              },
            },
          },
          padding: '0px',
          '& .overflow-item': {
            '&.editable': {
              '&:hover, &:active, &:focus': {
                textDecoration: 'none',
                backgroundColor: '#f3f2f1',
                '& .iconba-Edit': {
                  opacity: 1,
                },
                cursor: 'pointer',
              },
            },
            '& .entity-icon': {
              fontSize: '16px',
              color: '#106EBE',
              display: 'inline-block',
            },
            width: '100%',
            color: '#323130',
            padding: '0px 10px',
            minWidth: '170px',
            alignItems: 'center',
            '& .entity-label': {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          },
        },
      },
    },
    '.summary-bar-status': {
      '& .status-dropdown': {
        paddingTop: '2px',
        paddingBottom: '2px',
      },
    },
    '.summary-bar-overall-score': {
      display: 'flex',
      '& .summary-bar-overall-score-value': {
        marginLeft: '3px',
        marginRight: '10px',
        fontWeight: 600,
        fontSize: 12,
        color: palette.themePrimary,
      },
      '& .summary-bar-overall-score-chart': {
        marginTop: '2px',
      },
      '& .summary-bar-overall-score-none': {
        paddingLeft: '4px',
      },
    },
  },
});
